import React, { useMemo } from "react";
import { withAdmin } from "@/services/withAdmin";
import { IAdminFireBase } from "@/store/models/admin.models";
import styles from "./StoryTeller.module.scss";
import CustomTabs from "@/components/CustomTabs/CustomTabs";
import { useLocation, useNavigate } from "react-router-dom";
import { StoryTellerContent } from "./components/StoryTellerContent/StoryTellerContent";
import Layout from "@/components/Layout/Layout";
import { useGetProfileStoriesQuery } from "@/store/rtk-api/books.api";
import { IProfileStory } from "@/store/models/books.models";

const generateTabs = (profileStories: IProfileStory[]) => {
  return profileStories.map((story) => ({
    label: story.name,
    content: <StoryTellerContent type={story.name} />,
  }));
};

const getTabIndexFromPath = (path: string, tabs: { label: string }[]) => {
  const tab = decodeURIComponent(path.split("/").pop() || "");
  return tabs.findIndex((t) => t.label.toLowerCase() === tab.toLowerCase());
};

const StoryTellerCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { data: profileStories, isSuccess } = useGetProfileStoriesQuery({});

  const tabs = useMemo(
    () => generateTabs(profileStories || []),
    [profileStories]
  );

  const initialTab =
    tabs.length > 0 ? getTabIndexFromPath(location.pathname, tabs) : 0;

  const handleTabChange = (index: number) => {
    const selectedTab = encodeURIComponent(tabs[index].label.toLowerCase()); // Encode URL component
    navigate(`/story-teller/${selectedTab}`);
  };
  
  return (
    <Layout admin={admin}>
      <div className={styles.tabs}>
        {isSuccess && (
          <CustomTabs
            tabs={tabs}
            initialTab={initialTab}
            onTabChange={handleTabChange}
          />
        )}
      </div>
    </Layout>
  );
};

export const StoryTeller = withAdmin(StoryTellerCmp);
StoryTellerCmp.displayName = "StoryTellerCmp";

